import apiClient from './api';

const discService = {
  /**
   * Obtener todos los test DISC disponibles para un usuario
   */
  getDiscExamenesPorUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/disc-examenes/usuario/${usuarioId}`);
    return response.data;
  },

  /**
   * Procesar las respuestas del test DISC
   * @param {Object} data - { usuarioId, procesoId, respuestasMas: [], respuestasMenos: [] }
   */
  procesarTestDisc: async (data) => {
    const response = await apiClient.post('/disc/procesar', data);
    return response.data;
  },

  /**
   * Obtener el resultado de un test DISC
   */
  getResultadoTestDisc: async (testDiscId) => {
    const response = await apiClient.get(`/disc/resultado/${testDiscId}`);
    return response.data;
  },

  /**
   * Obtener tests DISC por proceso
   */
  getDiscExamenesPorProceso: async (procesoId) => {
    const response = await apiClient.get(`/disc-examenes/proceso/${procesoId}`);
    return response.data;
  },

  /**
   * Obtener todos los tests DISC (para supervisor/admin)
   */
  getAllDiscExamenes: async () => {
    const response = await apiClient.get('/disc-examenes');
    return response.data;
  },

  /**
   * Obtener tests DISC completados por usuario
   * @param {number} usuarioId - ID del usuario
   */
  getTestsCompletadosPorUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/disc/usuario/${usuarioId}`);
    return response.data;
  },

  /**
   * Obtener todos los tests DISC completados (resultados)
   */
  getTodosLosTestsCompletados: async () => {
    const response = await apiClient.get('/disc/todos');
    return response.data;
  },

  /**
   * Crear un nuevo examen DISC maestro
   * @param {number} usuarioId - ID del usuario que crea el examen (obligatorio)
   * @param {Object} data - { testDiscId, procesoId, estado, observaciones }
   * @returns {Object} El examen DISC creado con su ID
   */
  crearDiscExamen: async (usuarioId, data = {}) => {
    const body = {
      testDiscId: data.testDiscId || null,
      usuarioId: usuarioId,
      procesoId: data.procesoId || null,
      estado: data.estado || 'PENDIENTE',
      observaciones: data.observaciones || ''
    };
    const response = await apiClient.post('/disc-examenes', body);
    return response.data;
  },

  /**
   * Listar todos los DiscExamenes (maestros)
   */
  listarDiscExamenes: async () => {
    const response = await apiClient.get('/disc-examenes');
    return response.data;
  },
};

export default discService;
